import { Box, Dialog } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../View";
import { palette } from "../../theme/palette";

const useStyles = makeStyles(() => ({
  dialogContainer: {
    display: "flex",
    flexDirection: "row",
    fontWeight: 500,
    lineHeight: "20px",
    color: palette.typography.white.solid,
    padding: "30px",
    fontStyle: "normal",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "14px",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
  },
  textButton: {
    display: "flex",
    marginLeft: "15px",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
    cursor: "pointer",
    color: "#FFD500",
  },
}));

export const ConfirmDialog = ({
  children,
  open,
  onConfirm,
  onDecline,
  width,
}) => {
  const styles = useStyles();
  const paperStyle = {
    backgroundColor: "#303030",
    boxShadow: "none",
  };
  if (width) paperStyle.width = `${width}px`;

  return (
    <Dialog
      open={!!open}
      PaperProps={{
        style: paperStyle,
      }}
    >
      <Box className={styles.dialogContainer}>
        <Box>{children}</Box>

        <Box className={styles.buttonsContainer}>
          <View className={styles.textButton} onClick={onConfirm}>
            {onDecline ? "Yes" : "Ok"}
          </View>
          {onDecline ? (
            <View className={styles.textButton} onClick={onDecline}>
              No
            </View>
          ) : null}
        </Box>
      </Box>
    </Dialog>
  );
};
